import React, { useEffect } from "react";
import { Trophy } from "lucide-react";

const PBToast = ({ movement, value, unit, onDismiss }) => {
	useEffect(() => {
		const timer = setTimeout(() => {
			onDismiss();
		}, 5000);
		return () => clearTimeout(timer);
	}, [onDismiss]);

	return (
		<div
			style={{
				position: "fixed",
				top: "20px",
				left: "50%",
				transform: "translateX(-50%)",
				zIndex: 9999,
				display: "flex",
				alignItems: "center",
				gap: "12px",
				backgroundColor: "#1a1a1a",
				border: "2px solid #d15a36",
				borderRadius: "10px",
				padding: "16px 20px",
				boxShadow: "0 8px 32px rgba(209, 90, 54, 0.3)",
				animation: "pbToastSlideIn 0.4s ease-out",
				maxWidth: "360px",
			}}
		>
			<div
				style={{
					backgroundColor: "rgba(209, 90, 54, 0.15)",
					borderRadius: "50%",
					width: "40px",
					height: "40px",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					flexShrink: 0,
				}}
			>
				<Trophy size={22} style={{ color: "#d15a36" }} />
			</div>
			<div style={{ flex: 1, minWidth: 0 }}>
				<div
					style={{
						color: "#d15a36",
						fontWeight: 700,
						fontSize: "0.85rem",
						marginBottom: "2px",
					}}
				>
					New PB!
				</div>
				<div
					style={{
						color: "#fff",
						fontSize: "0.95rem",
						fontWeight: 600,
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
					}}
				>
					{movement} — {value} {unit}
				</div>
			</div>
			<button
				onClick={onDismiss}
				style={{
					background: "none",
					border: "none",
					color: "rgba(255,255,255,0.4)",
					cursor: "pointer",
					fontSize: "18px",
					lineHeight: 1,
					padding: "4px",
					flexShrink: 0,
				}}
				aria-label="Dismiss"
			>
				×
			</button>
		</div>
	);
};

export default PBToast;
